import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface SectionCardProps {
  title: string
  description?: string
  actions?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
  className?: string
}

export function SectionCard({
  title,
  description,
  actions,
  children,
  footer,
  className,
}: SectionCardProps) {
  return (
    <Card className={cn(className)}>
      <CardHeader
        className={actions ? 'flex flex-row items-start justify-between gap-4' : undefined}
      >
        <div>
          <CardTitle className="text-base font-semibold">{title}</CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </CardHeader>
      <CardContent>{children}</CardContent>
      {footer && (
        <div
          className="border-t border-border/50 bg-muted/30 px-5 py-3 rounded-b-[10px]"
          style={{ boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.03)' }}
        >
          {footer}
        </div>
      )}
    </Card>
  )
}
